/**
 * Central link registry — static defaults + API overrides.
 */
import { DEITIES } from "../deities";
import { FESTIVALS } from "../festivals";
import { VRATAS } from "../vratas";
import { STORIES } from "../stories";
import { SADHANAS } from "../sadhanas";
import { PANCHANGA_FESTIVAL_TO_LIBRARY, PANCHANGA_VRATA_TO_LIBRARY } from "./panchanga-links";

function entryLinks(type, entry) {
  return {
    id: entry.id,
    type,
    deity_ids: entry.deity_ids ?? [],
    festival_ids: entry.festival_ids ?? [],
    vrata_ids: entry.vrata_ids ?? [],
    story_ids: entry.story_ids ?? [],
    sadhana_ids: entry.sadhana_ids ?? [],
  };
}

/** Default registry from bundled catalogs + pañchāṅga id maps */
export function buildDefaultLinkRegistry() {
  const entries = [
    ...DEITIES.map((e) => entryLinks("deity", e)),
    ...FESTIVALS.map((e) => entryLinks("festival", e)),
    ...VRATAS.map((e) => entryLinks("vrata", e)),
    ...STORIES.map((e) => entryLinks("story", e)),
    ...SADHANAS.map((e) => entryLinks("sadhana", e)),
  ];

  for (const [panchId, libId] of Object.entries(PANCHANGA_FESTIVAL_TO_LIBRARY)) {
    const ex = entries.find((x) => x.type === "festival" && x.id === libId);
    if (ex) ex.panchanga_festival_id = panchId;
  }
  for (const [panchId, libId] of Object.entries(PANCHANGA_VRATA_TO_LIBRARY)) {
    const ex = entries.find((x) => x.type === "vrata" && x.id === libId);
    if (ex) ex.panchanga_vrata_id = panchId;
  }

  return entries;
}

let cachedRegistry = null;
let cachedOverrides = null;

export function getStaticLinkRegistry() {
  if (!cachedRegistry) cachedRegistry = buildDefaultLinkRegistry();
  return cachedRegistry;
}

export function setLinkRegistryOverrides(entries) {
  cachedOverrides = entries;
}

export function getLinkRegistryEntry(type, id) {
  const overrides = cachedOverrides ?? [];
  const o = overrides.find((e) => e.type === type && e.id === id);
  if (o) return o;
  return getStaticLinkRegistry().find((e) => e.type === type && e.id === id) ?? null;
}

/** Related topics for library cross-links */
export function getRelatedTopics(type, id) {
  const link = getLinkRegistryEntry(type, id);
  if (!link) return [];
  const out = [];
  const push = (t, i) => {
    if (i && !(t === type && i === id)) out.push({ type: t, id: i });
  };
  (link.deity_ids ?? []).forEach((i) => push("deity", i));
  (link.festival_ids ?? []).forEach((i) => push("festival", i));
  (link.vrata_ids ?? []).forEach((i) => push("vrata", i));
  (link.story_ids ?? []).forEach((i) => push("story", i));
  (link.sadhana_ids ?? []).forEach((i) => push("sadhana", i));
  return out.slice(0, 12);
}
